import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';

import CircleMessageGroup from './circle_message_group';
import Loader from '../loader';

export default createReactClass({
  displayName: 'Root',
  propTypes: {
    circleId: PropTypes.number,
    isCompany: PropTypes.bool,
  },
  getInitialState() {
    return {
      loading: true,
      data: {
        myCircles: [],
        hasUnreadMessage: {},
        pagenationSettings: {
          currentPage: 0,
          maxPerPage: 0,
          isLastPage: false,
        },
      },
      modalConfirmRef: React.createRef(),
    };
  },
  loadCircleMessageGroupListFromServer() {
    $.ajax({
      url: '/api/message/my_circle_list',
      dataType: 'json',
      cache: false,
      success: function (data) {
        this.setState({
          loading: false,
          data: data,
        });
      }.bind(this),
      error: function () {}.bind(this),
    });
  },
  loadMoreCircleMessageGroupListFromServer(page) {
    $.ajax({
      url: '/api/message/my_circle_list',
      dataType: 'json',
      data: {
        page: page + 1,
      },
      cache: false,
      success: function (data) {
        let newData = this.state.data;
        const currentCircleIds = this.state.data.myCircles.map(
          (circle) => circle.id
        );
        newData.myCircles = newData.myCircles.concat(
          data.myCircles.filter(
            (circle) => !currentCircleIds.includes(circle.id)
          )
        );
        newData.pagenationSettings = data.pagenationSettings;
        this.setState({
          loading: false,
          data: newData,
        });
      }.bind(this),
      error: function () {}.bind(this),
    });
  },
  componentDidMount() {
    this.loadCircleMessageGroupListFromServer();
    // $(window).on('focus', function() {
    //     this.loadCircleMessageGroupListFromServer();
    // }.bind(this));
    setInterval(this.loadCircleMessageGroupListFromServer, 13000);
  },
  render() {
    var currentCircleId = this.props.circleId;
    let isCompany = this.props.isCompany;
    var lastCircle =
      this.state.data.myCircles[this.state.data.myCircles.length - 1];
    const isLastPage = this.state.data.pagenationSettings.isLastPage;
    const currentPage = this.state.data.pagenationSettings.currentPage;
    var circleMessageGroup = this.state.data.myCircles.map((circle) => {
      return (
        <CircleMessageGroup
          circle={circle}
          currentCircleId={currentCircleId}
          hasUnreadMessage={false}
          key={circle.id}
          isCompany={isCompany}
          isLast={lastCircle == circle}
          unreadMessageCount={this.state.data.unreadMessageCount[circle.id]}
          lastMessage={this.state.data.lastMessages[circle.id]}
        />
      );
    });

    var circleMessageGroupList = (
      <p>
        <span className="txt-member">所属サークルがありません</span>
      </p>
    );
    const appLinkButton = isLastPage ? (
      ''
    ) : (
      <li
        onClick={() =>
          this.loadMoreCircleMessageGroupListFromServer(currentPage)
        }
        className="hov--default"
      >
        <div className="row justify-content-around align-items-center pt-3 pb-3 border-top">
          もっとみる
        </div>
      </li>
    );
    if (this.state.data.myCircles) {
      circleMessageGroupList = (
        <ul className="list-unstyled mb-0">
          {circleMessageGroup}
          {appLinkButton}
        </ul>
      );
    }
    return (
      this.state.data.myCircles.length > 0 && (
        <div>
          <div className="container col-md-8 col-lg-6">
            <h6 className="h6--list-title text-fz-14px text-black-50 pt-2">
              所属サークルのメッセージ
            </h6>
          </div>
          <div className="bg-white h-100 mb-2">
            <div className="container col-md-8 col-lg-6 h-100">
              <Loader isActive={this.state.loading} />
              {circleMessageGroupList}
            </div>
          </div>
        </div>
      )
    );
  },
});
